import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.766 15.441l-3.66 2.177a2 2 0 01-2.74-.696l-3.831-6.44a2 2 0 01-.22-1.515l.741-2.918a2 2 0 012.431-1.446l2.918.741a2 2 0 011.226.916l3.831 6.44a2 2 0 01-.696 2.742z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 6.118a1.996 1.996 0 011.64-.3l2.917.741a2 2 0 011.227.916l3.83 6.44a2 2 0 01-.696 2.741l-3.659 2.177a2 2 0 01-2.741-.696l-1.005-1.69",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "currentColor"
  })));
}

export { SvgDeals as ReactComponent };
